import request from'@/utils/request.js'

export default{
    Query(data) {
        return request({
            url: '/Case/Query',
            method: 'post',
            data
        })
    }    
} 